import React, { useEffect, useState } from "react";
import { ClickAwayListener } from "@material-ui/core";
import moment from "moment";

import "./prefilledRxDetailsDropdown.scss";
import arrow from "../../../../assets/down_arrow_blue.svg";
import deleteIcon from "../../../../assets/delete_icon_pre.svg";
import Question from "../../../../assets/question.PNG";

import SearchBarWithIcon from "../../../common/Modules/SearchBarWithIcon";
import C2CMiddlePopup from "../../../common/Popups/C2CMiddlePopup";
import AlertMsgPopup from "../../../common/AlertMsgPopup";
import { DELETE_SAVED_TEMPLATE } from "../../ERXViewApiHandler/apiConstants";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const PrefilledRxDetailsDropdown = (props) => {
  const {
    templatesList,
    pastConsultationsList,
    selectedTemplate,
    handleSelectedTemplate,
    handleSelectedPastConsultation,
    handleSetDefaultTemplate,
    search_string,
    getTemplatesApi,
    handleRemoveTemplateName,
  } = props;

  const [openDropdown, setOpenDropdown] = useState(false);
  const [showPastConsultations, setShowPastConsultations] = useState(false);
  const [searchtemplateList, setSearchTemplateList] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
  const [showAlertPopup, setShowAlertPopup] = useState(false);
  const [templateToDelete, setTemplateToDelete] = useState();
  const [disableBtn, setDisableBtn] = useState(false);

  const user_id = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  // LifeCycle ===>

  useEffect(() => {
    if (templatesList?.length > 0) {
      let filteredList = templatesList?.filter((template) =>
        template?.template_name
          ?.toLowerCase()
          ?.includes(searchString?.toLowerCase())
      );
      setSearchTemplateList(filteredList);
    }
  }, [templatesList, searchString]);

  // API call ===>

  const handleDeleteTemplateAPICall = (item) => {
    let reqPayload = {
      doctor_id: user_id,
      clinic_id: clinicId,
      template_id: item?.template_id,
    };
    const deleteTemplateResponse = c2cPostApiHandler(
      DELETE_SAVED_TEMPLATE,
      reqPayload
    );
    deleteTemplateResponse.then(([res, error]) => {
      if (!error) {
        setDisableBtn(false);
        if (res?.data?.statusCode === 200) {
          setShowDeleteConfirmPopup(false);
          setShowAlertPopup(true);
          getTemplatesApi();
          setTimeout(() => {
            setShowAlertPopup(false);
          }, 2000);
          if (item?.is_default_template === "True") {
            handleSetDefaultTemplate("");
          }
          if (item?.template_id === selectedTemplate?.id) {
            handleRemoveTemplateName();
          }
        }
      } else {
        setDisableBtn(false);
      }
    });
  };

  // Actions ===>

  const toggleDropdown = () => {
    setOpenDropdown(!openDropdown);
    if (!openDropdown) {
      setSearchString("");
    }
  };

  const handleShowPastConsultations = (val) => {
    setShowPastConsultations(val);
    if (val) {
      setSearchString("");
    }
  };

  const handleCloseDropdown = () => {
    setTimeout(() => {
      setOpenDropdown(false);
      setSearchString("");
    }, 10);
  };

  const handleSetDefaultTemplateClick = (e, item) => {
    e.stopPropagation();
    toggleDropdown();
    handleSelectedTemplate(item);
    handleSetDefaultTemplate(item?.template_id);
  };

  const handleRemoveDefaultTemplate = (e, item) => {
    e.stopPropagation();
    toggleDropdown();
    handleSetDefaultTemplate(item);
  };

  const handleDeleteTemplate = (e, item) => {
    e.stopPropagation();
    toggleDropdown();
    setTemplateToDelete(item);
    setShowDeleteConfirmPopup(true);
  };

  const handleConfirmDelete = () => {
    setDisableBtn(true);
    handleDeleteTemplateAPICall(templateToDelete);
  };

  const handleCloseDeletePopup = () => {
    setShowDeleteConfirmPopup(false);
  };

  // <===

  // Display UI ===>

  const displayPrefilledRxDetailsDropdown = () => {
    return (
      <ClickAwayListener onClickAway={handleCloseDropdown}>
        <div className="prefilled-rx-details-dropdown">
          <div className="prefilled-rx-details-dropdown-header-cont">
            <div
              className={
                "prefilled-rx-details-dropdown-header " +
                (!showPastConsultations
                  ? "prefilled-rx-details-dropdown-header-selected"
                  : "")
              }
              onClick={() => handleShowPastConsultations(false)}
            >
              Saved Rx Templates
            </div>
            <div
              className={
                "prefilled-rx-details-dropdown-header " +
                (showPastConsultations
                  ? "prefilled-rx-details-dropdown-header-selected"
                  : "")
              }
              style={{
                padding: showPastConsultations
                  ? "9px 7px 7px 3px"
                  : "9px 7px 9px 3px",
              }}
              onClick={() => handleShowPastConsultations(true)}
            >
              Past Consultations
            </div>
          </div>
          {!showPastConsultations ? (
            <>{displaySavedRxTemplates()}</>
          ) : (
            <>{displayPastConsultations()}</>
          )}
        </div>
      </ClickAwayListener>
    );
  };

  const displaySavedRxTemplates = () => {
    return (
      <div className="prefilled-rx-details-dropdown-values">
        <div className="prefilled-rx-details-dropdown-searchbar">
          <SearchBarWithIcon
            inputCallBack={(val) => setSearchString(val)}
            search_string={search_string}
            placeholder="Search Template"
            isClearable={true}
          />
        </div>
        {searchtemplateList.length !== 0 ? (
          searchtemplateList.map((item) => (
            <div
              key={item.template_id ? item.template_id : item.prescription_id}
              className={
                "prefilled-rx-details-dropdown-options " +
                (item.selected
                  ? "prefilled-rx-details-dropdown-options-selected"
                  : "")
              }
              onClick={() => {
                toggleDropdown();
                handleSelectedTemplate(item);
              }}
            >
              <div className="prefilled-rx-details-dropdown-value-container">
                <div>
                  <div
                    className="saved-rx-template-name"
                    style={{ color: item.selected ? "#fff" : "" }}
                  >
                    {item.template_name}
                  </div>
                  <div
                    className="saved-rx-template-date"
                    style={{ color: item.selected ? "#fff" : "" }}
                  >
                    {moment(item.created_at).utc().format("DD MMMM, YYYY")}
                  </div>
                </div>
                {item?.template_id && (
                  <div className="prefilled-rx-details-dropdown-buttons-container">
                    {item?.is_default_template !== "True" && (
                      <div
                        className="prefilled-rx-details-set-default-btn"
                        onClick={(e) => handleSetDefaultTemplateClick(e, item)}
                      >
                        Set as default
                      </div>
                    )}
                    {item?.is_default_template === "True" && (
                      <div
                        className="prefilled-rx-details-remove-default-btn"
                        onClick={(e) => handleRemoveDefaultTemplate(e, "")}
                      >
                        Remove Default
                      </div>
                    )}

                    <div className="prefilled-rx-details-dropdown-delete-container">
                      <div
                        className="prefilled-rx-details-dropdown-delete-button"
                        onClick={(e) => handleDeleteTemplate(e, item)}
                      >
                        <img
                          src={deleteIcon}
                          alt=""
                          className="prefilled-rx-details-dropdown-delete-icon"
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="prefilled-rx-details-dropdown-empty">No options</div>
        )}
      </div>
    );
  };

  const displayPastConsultations = () => {
    return (
      <div className="prefilled-rx-details-dropdown-values">
        {pastConsultationsList.length !== 0 ? (
          pastConsultationsList.map((item) => (
            <div
              key={item.prescription_id}
              className={
                "prefilled-rx-details-dropdown-options " +
                (item.selected
                  ? "prefilled-rx-details-dropdown-options-selected"
                  : "")
              }
              onClick={() => {
                toggleDropdown();
                handleSelectedPastConsultation(item);
              }}
            >
              <div className="past-consultations-date-patient">
                <span
                  className="past-consultations-date"
                  style={{ color: item.selected ? "#fff" : "" }}
                >
                  {moment(item.appointment_date).format("DD MMMM, YYYY") +
                    " - "}
                </span>
                <span
                  className="past-consultations-patient"
                  style={{ color: item.selected ? "#fff" : "" }}
                >
                  {item.patient_name}
                </span>
              </div>
              <div className="past-consultations-type-status">
                <span
                  className="past-consultations-type"
                  style={{ color: item.selected ? "#fff" : "" }}
                >
                  {item.appointment_type + " - " + item.consultation_type + " "}
                </span>
                <span
                  className="past-consultations-type-status-dot"
                  style={{ color: item.selected ? "#fff" : "" }}
                >
                  {" "}
                  &bull;
                </span>{" "}
                <span
                  className="past-consultations-status"
                  style={{
                    color: item.selected
                      ? "#fff"
                      : item.prescription_type.toLowerCase() === "saved"
                      ? ""
                      : "#E0228B",
                  }}
                >
                  {item.prescription_type}
                </span>
              </div>
            </div>
          ))
        ) : (
          <div className="prefilled-rx-details-dropdown-empty">No options</div>
        )}
      </div>
    );
  };

  // <===

  return (
    <>
      {" "}
      <div className="prefilled-rx-details-dropdown-cont">
        <div
          className="prefilled-rx-details-header-cont"
          onClick={toggleDropdown}
        >
          <div className="prefilled-rx-details-header">
            Pre-filled Rx Details
          </div>
          <img
            src={arrow}
            alt=""
            className={
              "prefilled-rx-details-header-arrow " +
              (openDropdown ? "up-arrow" : "down-arrow")
            }
          />
        </div>
        {openDropdown && displayPrefilledRxDetailsDropdown()}
      </div>
      <C2CMiddlePopup
        openPopup={showDeleteConfirmPopup}
        hideCloseIcon={true}
        titleImg={Question}
        title="Do you want to delete this template?"
        leftBtnDisable={disableBtn}
        leftBtn={"Yes"}
        rightBtn={"No"}
        handleLeftBtnClick={handleConfirmDelete}
        handleRightBtnClick={handleCloseDeletePopup}
      />
      {showAlertPopup && (
        <div className="prefilled-rx-delete-message">
          <AlertMsgPopup
            alertMsg={"You have successfully deleted the template"}
          />
        </div>
      )}
    </>
  );
};

export default PrefilledRxDetailsDropdown;
